'use strict';
module.exports = ([function () {
        return function (sourceId, sourceList) {
            var ret = "";
            if (sourceId !== undefined && sourceList && sourceList.length) {
                angular.forEach(sourceList, function (s) {
                    if (s.id === sourceId) {
                        
                        ret= s.comment.comment;
                    }
                });
            }
            return ret;
        };
    }]);



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-AstralSituationRecord/components/filters/sourceTranscodeFilter.js
// module id = 275
// module chunks = 0